import React, { useState } from 'react';
import {
  makeStyles,
  Checkbox,
  FormControl,
  FormControlLabel
} from '@material-ui/core';
import { t } from 'src/shared/literals';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  },
  checkboxField: {
    margin: 2,
    paddingTop: '17px'
  }
}));

const FormCheckBox = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const { name, value, readonly, errorMessage } = field;

  const [checked, setChecked] = useState(value);

  const handleChange = (e) => {
    if (readonly) {
      return;
    }

    setChecked(e.target.checked);

    handleChangeField(e);
  };

  return (
    <FormControl className={classes.formControl} key={name}>
      <FormControlLabel
        className={classes.checkboxField}
        value={t(name.toString())}
        control={
          <Checkbox
            name={name}
            color="primary"
            checked={checked}
            onChange={handleChange}
            InputProps={{
              readOnly: readonly
            }}
            error={Boolean(errorMessage)}
            helperText={t(errorMessage)}
          />
        }
        label={t(name.toString())}
        labelPlacement="end"
      />
    </FormControl>
  );
};

export default FormCheckBox;
